import { render, staticRenderFns } from "./QuestionarioQualita.vue?vue&type=template&id=87a4abcc&scoped=true&"
import script from "./QuestionarioQualita.vue?vue&type=script&lang=js&"
export * from "./QuestionarioQualita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a4abcc",
  null
  
)

export default component.exports